export default __webpack_public_path__ + "static/media/softball.f2e2fdf4.svg";